import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import MyModal from './MyModal';

class ModalAlerta extends AbstractComponent {    
    fechar() {
        if(this.props.fechar !== undefined) {
            this.props.fechar();
        }
    }

    render() {
        return (
            <MyModal styleHeader="bg-danger"
                     styleIcon="fa fa-exclamation-triangle"
                     styleText={this.props.styleText}
                     className="modal_alert "                     
                     classNameButton="btnDange"
                     styleButton="btn btn-danger"
                     show={this.props.show}                      
                     header={this.props.header}
                     texto={this.props.texto}                     
                     buttonTxt="Ok" 
                     fechar={e => this.fechar()} />            
        )
    }
}

ModalAlerta.defaultProps = {
    header: 'Alerta',
    styleText: ''
}

export default ModalAlerta;